<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage tiles">
      <b-card-header>
        <i :class="icon" class="mr-1"></i>
        <!-- <CIcon :name="icon" /> -->
        {{ title }}
        <div class="card-header-actions">
          <b-button size="sm" variant="outline-primary" class="card-header-action mr-1" @click="layout_refresh()"
            :disabled="layout_edit">
            <i class="fa fa-refresh"></i>
          </b-button>

          <b-button size="sm" variant="outline-primary" class="card-header-action" :disabled="layout_edit"
            v-b-toggle.addtile>
            <i class="fa fa-plus-square"></i>
          </b-button>
        </div>
      </b-card-header>

      <b-card-body class="px-0">
        <!-- <b-row class="px-3">
          <b-col>
            <div id="refresh">
              <div v-if="window.width > 768">
                <span class="mr-2">Auto refresh:</span>
                <b-button v-if="refresh_at > 0" id="refresh_popover-id" size="sm" variant="outline-primary" ref="button"
                  style="width: 100px">{{ refresh_at }} minute(s)</b-button>
                <b-button v-if="refresh_at == 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                  ref="button" class="ml-2" style="width: 100px">Off</b-button>
              </div>
              <div v-else>
                <b-row>
                  <b-col cols="12" md="6">Auto refresh:</b-col>
                  <b-col>
                    <b-button v-if="refresh_at > 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                      ref="button" style="width: 100px">{{ refresh_at }} minute(s)</b-button>
                    <b-button v-if="refresh_at == 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                      ref="button" class="ml-2" style="width: 100px">Off</b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
            <b-popover target="refresh_popover-id" :show.sync="refresh_popover" triggers="click" placement="bottom"
              container="refresh" ref="popover">
              <div>
                <b-form-radio-group class="mt-2 mb-2" name="Auto Refresh Every" v-model="refresh_at" :options="[
                  { text: 'Off', value: 0 },
                  { text: '1 min', value: 1 },
                  { text: '5 min', value: 5 },
                  { text: '10 min', value: 10 },
                ]" stacked></b-form-radio-group>

                <b-button @click="refresh_popover = false" size="sm" variant="outline-primary"
                  class="ml-2">OK</b-button>
              </div>
            </b-popover>
          </b-col>
          <b-col align-self="end" class="text-right">
            <div v-if="window.width > 768">
              <span class="mr-2">Last updated:</span>
              <span class="text-primary">{{ refresh_timeago }}</span>
            </div>
            <div v-else>
              <b-row>
                <b-col class="text-right" cols="12" md="6">Last updated:</b-col>
                <b-col>
                  <span class="text-primary">{{ refresh_timeago }}</span>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row> -->
        <b-row class="px-3 mt-4">
          <b-button-group class="ml-3">
            <b-row no-gutters>
              <b-col cols="auto">
                <b-button squared size="sm" :title="title + ' tiles'" :variant="toolbar_variant"
                  :pressed="selectedComponent == null" @click="selectedComponent = null"><i
                    class="fa fa-home pr-3"></i>Home</b-button></b-col>
              <b-col cols="auto" v-if="permissionvalid('bookingforms.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'BookingForms'"
                  @click="selectedComponent = 'BookingForms'">
                  <i class="fa fa-tasks mr-1"></i>Booking Forms
                </b-button></b-col>
              <b-col cols="auto" v-if="permissionvalid('orders.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'Orders'"
                  @click="selectedComponent = 'Orders'">
                  <i class="fa fa-gavel pr-3"></i>Orders
                </b-button></b-col>
              <b-col cols="auto" v-if="permissionvalid('conferma.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'InventoryLines'"
                  @click="selectedComponent = 'InventoryLines'">
                  <i class="fa fa-puzzle-piece mr-1"></i>Charges
                </b-button></b-col>
              <b-col cols="auto" v-if="permissionvalid('charters.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'Charters'"
                  @click="selectedComponent = 'Charters'">
                  <i class="fa fa-fighter-jet mr-1"></i>Charters</b-button></b-col>
              <b-col cols="auto" v-if="permissionvalid('tickets.view')">
                <b-button squared size="sm" :variant="toolbar_variant"
                  :pressed="selectedComponent == 'TicketsRepository'" @click="selectedComponent = 'TicketsRepository'">
                  <i class="fa fa-ticket mr-1"></i>Tickets</b-button></b-col>
              <b-col cols="auto" v-if="permissionvalid('bookings.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'Bookings'"
                  @click="selectedComponent = 'Bookings'">
                  <i class="fa fa-hotel pr-3"></i>Bookings (GDS)
                </b-button>
              </b-col>

              <!-- <b-col cols="auto" v-if="permissionvalid('cars.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'CarBookings'"
                  @click="selectedComponent = 'CarBookings'">
                  <i class="fa fa-car pr-3"></i>Cars
                </b-button></b-col> -->
              <b-col cols="auto" v-if="permissionvalid('carhire.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'CarHire'"
                  @click="selectedComponent = 'CarHire'">
                  <i class="fa fa-car pr-3"></i>Car Hire
                </b-button></b-col>
              <!-- 
              <b-col cols="auto" v-if="permissionvalid('cars.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'CarsRepository'"
                  @click="selectedComponent = 'CarsRepository'">
                  <i class="fa fa-car pr-3"></i>Cars
                </b-button></b-col>
              > -->

              <!-- <b-col cols="auto" v-if="permissionvalid('salesledger.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'SLTransactions'"
                  @click="selectedComponent = 'SLTransactions'">
                  <i class="fa fa-wpforms pr-3"></i>Invoices
                </b-button></b-col> -->


              <!-- <b-col cols="auto" v-if="permissionvalid('clients.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'Clients'"
                  @click="selectedComponent = 'Clients'">
                  <i class="fa fa-handshake-o pr-3"></i>
                  Clients
                </b-button></b-col>

              <b-col cols="auto" v-if="permissionvalid('suppliers.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'Suppliers'"
                  @click="selectedComponent = 'Suppliers'">
                  <i class="fa fa-industry pr-3"></i>Suppliers
                </b-button></b-col>

              <b-col cols="auto" v-if="permissionvalid('events.view')">
                <b-button squared size="sm" :variant="toolbar_variant" :pressed="selectedComponent == 'Events'"
                  @click="selectedComponent = 'Events'">
                  <i class="fa fa-calendar-check-o pr-3"></i>Events
                </b-button></b-col> -->

            </b-row>
          </b-button-group>
        </b-row>
        <div v-if="selectedComponent == null" class="dashboard_layout mt-4 ml-3">
          <b-row no-gutters :style="layout_edit ? 'background-color:rgba(225, 225, 225, 0.1)' : ''
            ">
            <b-col :cols="item.cols" :md="item.md" :lg="item.lg" v-for="(item, index) in layout_grid" :key="index"
              no-body class="pr-3">
              <b-card class="ml-0" no-body :border-variant="tile_selected == index ? 'secondary' : null"
                style="border-radius: 0" @mouseover="!tile_settings ? (tile_selected = index) : null">
                <div class="popover-actions" :id="'actions-container-' + index.toString()">
                  <b-button v-show="tile_selected == index" variant="link" size="sm" title="Actions" squared
                    :id="'popover-target-' + index.toString()" class="float-right p-0">
                    <i class="fa fa-ellipsis-h text-primary"></i>
                  </b-button>
                </div>
                <b-popover :container="'actions-container-' + index.toString()"
                  :target="'popover-target-' + index.toString()" triggers="hover" placement="leftbottom">
                  <div>
                    <b-nav vertical>
                      <section v-for="(action, index) in defaultOptions.layout_grid[
                        index
                      ].options.actions" :key="index">
                        <b-nav-item v-if="!action.divider" :title="action.label"
                          @click.stop="invoke_action(action, index)">
                          <b-row class="px-2">
                            <b-col class="px-0">
                              <span class="text-normal">{{
                                action.label
                              }}</span>
                            </b-col>
                            <b-col cols="1">
                              <i :class="action.icon" class="text-primary"></i>
                            </b-col>
                          </b-row>
                        </b-nav-item>
                        <div class="divider" v-if="action.divider"></div>
                      </section>
                    </b-nav>
                  </div>
                </b-popover>
                <component :is="item.name" :tile="item" :refresh="refresh" @refreshed="refresh = false"></component>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <div class="px-3 mt-3">
          <component :is="selectedComponent" :search="search" :refresh="refresh" @refreshed="refresh = false" />
        </div>
      </b-card-body>
    </b-card>
    <TileAdd />
    <TileSettings v-if="tile_selected || tile_selected == 0" :tile="defaultOptions.layout_grid[tile_selected]
      ? defaultOptions.layout_grid[tile_selected]
      : { name: 'Empty Settings', settings: [] }
      " @apply="saveTile" @cancel="tile_settings = false" />
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

// import Events from "./Apps/Accounts/Events";
// import Clients from "./Apps/Accounts/Clients";
// import Suppliers from "./Apps/Accounts/Suppliers";

import Orders from "./Apps/Orders/Orders";
import SLTransactions from "./Apps/Accounts/SLTransactions2";

import BookingForms from "./Apps/Accounts/BookingForms2";
import InventoryLines from "./Apps/Charges/InventoryLines";
import Charters from "./Apps/Charters/Charters";
import TicketsRepository from "./Apps/Tickets/TicketsRepository";
import Bookings from "./Apps/Bookings/Bookings";
//import HotelsRepository from "./Apps/Hotels/HotelsRepository";
//import CarsRepository from "./Apps/Cars/CarsRepository";
import CarBookings from "./Apps/Cars/CarBookings";
import CarHire from "./Apps/Cars/CarHire";

export default {
  name: "General",
  components: {
    BookingForms,
    InventoryLines,
    Charters,
    TicketsRepository,
    Bookings,
    //HotelsRepository,
    //CarsRepository,
    CarBookings,
    CarHire,
    SLTransactions,
    Orders,
    // Suppliers,
    // Clients,
    // Events,
  },
  async activated() {
    console.log("dashboard is activated");
    this.layout_refresh();
  },
  deactivated() {
    console.log("dashboard is deactivated");
    clearInterval(this.timer_time);
    clearInterval(this.timer_refresh);
  },
  data() {
    return {
      title: "Dashboard",
      icon: "fa fa-tachometer",
      toolbar_variant: "outline-primary",
      busy: false,
      refresh: false,
      refresh_at: 5,
      refresh_time: new Date(),
      refresh_timeago: "",
      refresh_popover: false,
      layout_grid: [],
      layout_edit: false,
      tile_selected: null,
      tile_settings: false,
      timer_time: null,
      timer_refresh: null,
      defaultOptions: {
        layout_grid: [
          // {
          //   moved: false,
          //   id: "0f9085d8-b594-40f0-8e0f-642042af2ee2",
          //   name: "Welcome",
          //   cols: 12,
          //   lg: 12,
          //   settings: [
          //     {
          //       key: "type",
          //       label: "Chart Type",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "table", text: "Table" }],
          //       value: "table",
          //     },
          //     {
          //       key: "fileid",
          //       label: "File Id",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [{ value: "navitas_log", text: "navitas_log" }],
          //       value: "navitas_log",
          //     },
          //     {
          //       key: "title",
          //       label: "Title",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: true,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "titletext",
          //       label: "Title Text",
          //       type: "text",
          //       value: "ETRPStatus",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legend",
          //       label: "Legend",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "legendposition",
          //       label: "Legend Position",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: "top", text: "Top" },
          //         { value: "bottom", text: "Bottom" },
          //         { value: "left", text: "Left" },
          //         { value: "right", text: "Right" },
          //       ],
          //       value: "bottom",
          //       tab: "Annotate",
          //     },
          //     {
          //       key: "datalabels",
          //       label: "Data Labels",
          //       type: "radio-group",
          //       buttons: true,
          //       "button-variant": "outline-primary",
          //       values: [
          //         { value: true, text: "On" },
          //         { value: false, text: "Off" },
          //       ],
          //       value: false,
          //       tab: "Annotate",
          //     },

          //     {
          //       key: "titlefontnamesize",
          //       label: "",
          //       label_type: "Font Type",
          //       label_size: "Font Size",
          //       type: "fontsize",
          //       values_type: [
          //         { value: "Arial", text: "Arial" },
          //         { value: "Helvetica Neue", text: "Helvetica Neue" },
          //       ],
          //       values_size: [
          //         { value: "10", text: "10" },
          //         { value: "12", text: "12" },
          //         { value: "14", text: "14" },
          //       ],
          //       tab: "Fonts",
          //     },
          //   ],
          //   options: {
          //     actions: [
          //       {
          //         key: "settings",
          //         label: "Settings",
          //         icon: "fa fa fa-cog text-primary",
          //       },
          //       { divider: true },
          //       { key: "small", label: "Small", icon: "fa fa-th text-primary" },
          //       {
          //         key: "large",
          //         label: "Large",
          //         icon: "fa fa-square text-primary",
          //       },
          //       { divider: true },
          //       {
          //         key: "delete",
          //         label: "Delete",
          //         icon: "fa fa-trash text-danger",
          //       },
          //     ],
          //   },
          // },
          {
            moved: false,
            id: "0f9085d8-b594-40f0-8e0f-642042af2ee2",
            name: "Welcome1",
            cols: 12,
            lg: 12,
            settings: [
              {
                key: "type",
                label: "Chart Type",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [{ value: "table", text: "Table" }],
                value: "table",
              },
              {
                key: "fileid",
                label: "File Id",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [{ value: "navitas_log", text: "navitas_log" }],
                value: "navitas_log",
              },
              {
                key: "title",
                label: "Title",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: true,
                tab: "Annotate",
              },
              {
                key: "titletext",
                label: "Title Text",
                type: "text",
                value: "ETRPStatus",
                tab: "Annotate",
              },
              {
                key: "legend",
                label: "Legend",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: false,
                tab: "Annotate",
              },
              {
                key: "legendposition",
                label: "Legend Position",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: "top", text: "Top" },
                  { value: "bottom", text: "Bottom" },
                  { value: "left", text: "Left" },
                  { value: "right", text: "Right" },
                ],
                value: "bottom",
                tab: "Annotate",
              },
              {
                key: "datalabels",
                label: "Data Labels",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: false,
                tab: "Annotate",
              },

              {
                key: "titlefontnamesize",
                label: "",
                label_type: "Font Type",
                label_size: "Font Size",
                type: "fontsize",
                values_type: [
                  { value: "Arial", text: "Arial" },
                  { value: "Helvetica Neue", text: "Helvetica Neue" },
                ],
                values_size: [
                  { value: "10", text: "10" },
                  { value: "12", text: "12" },
                  { value: "14", text: "14" },
                ],
                tab: "Fonts",
              },
            ],
            options: {
              actions: [
                {
                  key: "settings",
                  label: "Settings",
                  icon: "fa fa fa-cog text-primary",
                },
                { divider: true },
                { key: "small", label: "Small", icon: "fa fa-th text-primary" },
                {
                  key: "large",
                  label: "Large",
                  icon: "fa fa-square text-primary",
                },
                { divider: true },
                {
                  key: "delete",
                  label: "Delete",
                  icon: "fa fa-trash text-danger",
                },
              ],
            },
          },
        ],
      },
      reponsiveGrid: {
        layouts: {
          md: [
            { x: 0, y: 0, w: 5, h: 6, i: "1" },
            { x: 5, y: 0, w: 5, h: 6, i: "2" },
            // { x: 0, y: 25, w: 5, h: 6, i: "3" },
            // { x: 5, y: 25, w: 3, h: 6, i: "4" },
          ],
        },
        breakpoint: "md",
        components: {
          1: { i: "1", component: "NLPost", defaultSize: 2 },
        },
        cols: 10,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        colsAll: { lg: 10, md: 8, sm: 6, xs: 4, xxs: 2 },
        isDraggable: true,
        isResizable: true,
      },
      selectedComponent: null,
      search: null,
    };
  },
  watch: {
    refresh: {
      // immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.refresh_time = new Date();
        }
      },
    },
  },
  computed: {
    ...mapGetters(["window", "user"]),
  },
  methods: {
    async loadData() {
      console.log("loadData");
      this.busy = true;

      // OVERIDE THE DATA
      this.layout_grid = this.defaultOptions.layout_grid;

      this.busy = false;
      // this.layout_autorefresh();
    },
    async saveData() {
      console.log("saveData", this.layout);
      this.busy = true;

      this.busy = false;
      this.layout_edit = false;
    },
    async saveTile(t) {
      console.log("saveTile", this.tile_selected, t);
      this.layout_grid[this.tile_selected] = t;
      this.refresh = true;
      this.tile_settings = false;
    },
    invoke_action(s, r) {
      console.log("invoke action", s, r);
      if (s.key) {
        console.log(s.key);
        switch (s.key) {
          case "settings":
            this.tile_settings = true;
            this.$root.$emit("bv::toggle::collapse", "tilesettings");
            break;
        }
      }
    },
    async layout_refresh() {
      this.refresh = true;
      await this.loadData();
    },
    layout_autorefresh() {
      return
      this.refresh_time = new Date();
      this.refresh = true;
      clearInterval(this.timer_time);
      clearInterval(this.timer_refresh);
      if (this.refresh_at > 0) {
        this.timer_refresh = setInterval(() => {
          this.layout_autorefresh();
        }, 100000);
        if (this.refresh_at > 0) {
          this.timer_time = setInterval(() => {
            this.layout_timeago();
          }, 10000);
        }
        this.layout_timeago();
      }
      this.$store.dispatch("notifications");
      console.log("layout_autorefresh");
    },
    layout_timeago() {
      return
      this.refresh_timeago = this.$options.filters.formatTimeago(
        this.refresh_time
      );
      console.log("layout_timeago");
    },
  },
};
</script>

<style></style>
